// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Business theme tokens — defaults (Heritage gold).
   ThemeRoot (src/theme/BrandingProvider.js) overwrites these on <html>
   with the open business's palette; see src/theme/palette.js for how
   each shade derives from the three seed colours. Stylesheets read
   these instead of hard-coding the brand hues, so pages, modals and
   print pages all follow the business. */
:root {
  --rf-brand: #8f7136;
  --rf-brand-hover: #785d2a;
  --rf-brand-deep: #6b5629;
  --rf-brand-lite: #b79856;
  --rf-brand-soft: #c9ac74;
  --rf-brand-pale: #dcc79a;
  --rf-brand-bright: #e8c98a;
  --rf-brand-line: #e6dcc6;
  --rf-brand-edge: #ece0c6;
  --rf-brand-tint: #f7f1e3;
  --rf-brand-wash: #fdfaf3;
  --rf-accent: #3f6f6a;
  --rf-accent-tint: #eef4f3;
  --rf-header: #8e7036;
  --rf-header-cream: #ece2cb;

  --rf-brand-rgb: 143, 113, 54;
  --rf-brand-lite-rgb: 183, 152, 86;
  --rf-brand-tint-rgb: 247, 241, 227;
  --rf-header-cream-rgb: 236, 226, 203;
  --rf-accent-rgb: 63, 111, 106;

  --rf-logo-h: 36px;
  --rf-logo-print-h: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/theme/theme.css"],"names":[],"mappings":"AAAA;;;;;yCAKyC;AACzC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,0BAA0B;EAC1B,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,oBAAoB;EACpB,yBAAyB;EACzB,oBAAoB;EACpB,0BAA0B;;EAE1B,4BAA4B;EAC5B,iCAAiC;EACjC,kCAAkC;EAClC,oCAAoC;EACpC,6BAA6B;;EAE7B,iBAAiB;EACjB,uBAAuB;AACzB","sourcesContent":["/* Business theme tokens — defaults (Heritage gold).\n   ThemeRoot (src/theme/BrandingProvider.js) overwrites these on <html>\n   with the open business's palette; see src/theme/palette.js for how\n   each shade derives from the three seed colours. Stylesheets read\n   these instead of hard-coding the brand hues, so pages, modals and\n   print pages all follow the business. */\n:root {\n  --rf-brand: #8f7136;\n  --rf-brand-hover: #785d2a;\n  --rf-brand-deep: #6b5629;\n  --rf-brand-lite: #b79856;\n  --rf-brand-soft: #c9ac74;\n  --rf-brand-pale: #dcc79a;\n  --rf-brand-bright: #e8c98a;\n  --rf-brand-line: #e6dcc6;\n  --rf-brand-edge: #ece0c6;\n  --rf-brand-tint: #f7f1e3;\n  --rf-brand-wash: #fdfaf3;\n  --rf-accent: #3f6f6a;\n  --rf-accent-tint: #eef4f3;\n  --rf-header: #8e7036;\n  --rf-header-cream: #ece2cb;\n\n  --rf-brand-rgb: 143, 113, 54;\n  --rf-brand-lite-rgb: 183, 152, 86;\n  --rf-brand-tint-rgb: 247, 241, 227;\n  --rf-header-cream-rgb: 236, 226, 203;\n  --rf-accent-rgb: 63, 111, 106;\n\n  --rf-logo-h: 36px;\n  --rf-logo-print-h: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
